import { Group, useAppSelector } from "@lib/store";
import { MAX_GROUP_MEMBERS } from "@lib/store/src/data/groups/constants";
import { Avatar, Button } from "@molecules";
import { H4, Subtitle } from "@quarks";
import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";

export const GroupInviteInvitedBySection = ({ groupInvite }: { groupInvite: Group }) => {
  const { t } = useTranslation();
  const currentUserId = useAppSelector(state => state.data.user.user.id);

  const [showMore, setShowMore] = useState(false);

  const creator = useMemo(
    () => groupInvite?.members.find(member => member.user.id === currentUserId)?.invitedByUser,
    [groupInvite, currentUserId],
  );

  return (
    <div className="flex flex-col gap-4">
      {creator && (
        <div className="flex flex-row gap-3 items-center">
          <div className="flex-shrink-0">
            <Avatar
              user={creator}
              shouldShowCheckIn
            />
          </div>
          <div className="grid">
            <H4 className="">Group invitation</H4>
            <Subtitle className="text-sm">{creator.name}</Subtitle>
          </div>
        </div>
      )}

      <Subtitle className="">
        {t("groups:GroupInviteInfoPart1")}
        {showMore && (
          <span className="mt-4 block">{t("groups:GroupInviteInfoPart2", { limit: MAX_GROUP_MEMBERS })}</span>
        )}{" "}
        <Button
          className="inline"
          button="text"
          onClick={() => setShowMore(v => !v)}>
          {showMore ? t("ShowLess") : t("ShowMore")}
        </Button>
      </Subtitle>
    </div>
  );
};
